namespace TabAurous.Finance {
    export interface PDCPayableForm {
        TransDate: Serenity.DateEditor;
        VoucherNo: Serenity.StringEditor;
        InvoiceNo: Serenity.StringEditor;
        PartyId: Serenity.LookupEditor;
        BankId: Serenity.LookupEditor;
        Amount: Serenity.DecimalEditor;
        ChequeNo: Serenity.MaskedEditor;
        ChequeDate: Serenity.DateEditor;
        CreatedBy: Serenity.LookupEditor;
        RefNo: Serenity.StringEditor;
        RefDate: Serenity.DateEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        ExtraDate: Serenity.DateEditor;
        Extra1: Serenity.StringEditor;
        Extra2: Serenity.StringEditor;
        CompanyId: Serenity.IntegerEditor;
        Narration: Serenity.StringEditor;
    }

    export class PDCPayableForm extends Serenity.PrefixedContext {
        static formKey = 'Finance.PDCPayable';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PDCPayableForm.init)  {
                PDCPayableForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.LookupEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.MaskedEditor;
                var w5 = s.IntegerEditor;

                Q.initFormType(PDCPayableForm, [
                    'TransDate', w0,
                    'VoucherNo', w1,
                    'InvoiceNo', w1,
                    'PartyId', w2,
                    'BankId', w2,
                    'Amount', w3,
                    'ChequeNo', w4,
                    'ChequeDate', w0,
                    'CreatedBy', w2,
                    'RefNo', w1,
                    'RefDate', w0,
                    'VoucherTypeId', w5,
                    'FinancialYearId', w5,
                    'ExtraDate', w0,
                    'Extra1', w1,
                    'Extra2', w1,
                    'CompanyId', w5,
                    'Narration', w1
                ]);
            }
        }
    }
}
